module.exports = new __parcel__URL__("connected_earth_wildfire.450fdbc6.png").toString();